module.exports = __webpack_public_path__ + "static/media/SM.1c2c8e92.png";